// Import Hook modules
import FileuploadClear from './fileupload_clear';

export default {
  ...FileuploadClear,
};
